import { render, staticRenderFns } from "./AutoDeliveryMonitor.vue?vue&type=template&id=70bd3878&"
import script from "./AutoDeliveryMonitor.vue?vue&type=script&lang=js&"
export * from "./AutoDeliveryMonitor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70bd3878')) {
      api.createRecord('70bd3878', component.options)
    } else {
      api.reload('70bd3878', component.options)
    }
    module.hot.accept("./AutoDeliveryMonitor.vue?vue&type=template&id=70bd3878&", function () {
      api.rerender('70bd3878', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/auto-delivery-monitor/AutoDeliveryMonitor.vue"
export default component.exports